import '../../../../styles/knowledge-concept/learning-interface/LearningInterface.css';
import 'react-toastify/dist/ReactToastify.css';

import { Box, Button, Popover } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { addNotebook, setNotebook } from '../../../../store/notebookSlice.js';
import {
	fetchNotebookData,
	getLatestNotebookId,
	latestBoxId,
	saveNotebook,
} from '../../../../services/DashboardApi.js';
import {
	getAIContentData,
	getConceptQuiz,
	saveQuizData,
} from '../../../../services/DashboardApi.js';
import { useDispatch, useSelector } from 'react-redux';

import AIContent from '../ai-content/AIContent.jsx';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import DescriptionIcon from '../../../../assets/DescriptionIcon.svg'; // Import the file path
import Flashcard from '../flashcard/FlashCard.jsx';
import LightbulbIcon from '../../../../assets/LightbulbIcon.svg';
import Loader from '../../../atoms/Loader.jsx';
import NotesMenu from './NotesMenu.jsx';
import QuizPage from '../quiz/QuizPage.jsx';
import SchoolIcon from '../../../../assets/SchoolIcon.svg';
import UploadFileIcon from '../../../../assets/UploadFileIcon.svg';
import { debounce } from 'lodash';
import { logger } from '../../../../utils/logger';
import { v4 as uuidv4 } from 'uuid';

const LearningInterface = ({
	// topicId,
	// subtopicId,
	// notebookId,
	handleNoteBookSelection,
	handleCreateNotebook,
	setSidebarState,
}) => {
	const [aiContentData, setAIContent] = useState([]);
	const [flashcard_content, setFlashCardContent] = useState([]);
	const [currentView, setCurrentView] = useState(null);
	const [boxes, setBoxes] = useState([]);
	const [showFallback, setShowFallback] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const selectedSubTopicDetails = useSelector(
		(state) => state.selectedSubTopic.selectedSubTopicData
	);
	const selectedMainTab = useSelector((state) => state.mainTab.tab_name);

	//const [flashcardHeaderClicked, setFlashcardHeaderClicked] = useState({});
	const dispatch = useDispatch();
	const topicId = selectedSubTopicDetails.topicId;
	const subtopicId = selectedSubTopicDetails.subtopicId;
	const notebookId = selectedSubTopicDetails.notebookId;
	const topicName = selectedSubTopicDetails.topicName;
	const subtopicName = selectedSubTopicDetails.subtopicName;
	const divRef = useRef({});
	const [anchorPosition, setAnchorPosition] = useState(null);
	const [popoverState, setPopoverState] = useState(false);
	const [subject, setSubject] = useState('');
	const [newBoxId, setNewBoxId] = useState(null);
	const { userId } = useSelector((state) => state.userDetails);
	const { notebookList, currentNotebook } = useSelector((state) => state.notebook);

	const [conceptQuizData, setConceptQuizData] = useState([]);
	const [error, setError] = useState(null);
	const quizBoxRef = useRef(null);
	const generatingQuizBoxRef = useRef(null);
	const [activeBox, setActiveBox] = useState(null);
	const [sortedBoxes, setSortedBoxes] = useState([]);
	const [mainPageLoader, setMainPageLoader] = useState(false);

	useEffect(() => {
		const scrollContainer = document.querySelector('.scrollable-content'); // Replace with your actual className

		if (!scrollContainer) return;

		const handleScroll = debounce(() => {
			let closestBox = null;
			let minDistance = Infinity;

			sortedBoxes.forEach((box) => {
				const boxElement = document.getElementById(box.BOX_ID);
				if (boxElement) {
					const boxTop = boxElement.offsetTop - scrollContainer.scrollTop;
					const distance = Math.abs(boxTop);

					if (distance < minDistance) {
						minDistance = distance;
						closestBox = box.CONTENT_TYPE;
					}
				}
			});

			if (closestBox) {
				setActiveBox(closestBox);
			}
		}, 100);

		scrollContainer.addEventListener('scroll', handleScroll);

		// Run initially in case the user is already scrolled
		handleScroll();

		return () => {
			scrollContainer.removeEventListener('scroll', handleScroll);
			// cancelAnimationFrame(animationFrameId); // Clean up animation frame
		};
	}, [sortedBoxes]);

	useEffect(() => {
		if (!Boolean(currentNotebook) && notebookList.length > 0) {
			dispatch(setNotebook(notebookList[0]?.NOTEBOOK_ID));
			handleNoteBookSelection(
				notebookList[0]?.TOPIC_ID,
				notebookList[0]?.SUBTOPIC_ID,
				notebookList[0]?.NOTEBOOK_ID
			);
		} else if (notebookList.length === 0) {
			//call function for notebook creation
			handleCreateNotebook('Default Notebook');
		}
	}, []);

	useEffect(() => {
		if (!topicId || !subtopicId) return;
		logger.log('Notebook Id inside useEffect: ', notebookId);
		/*if(!notebookId){
      setAIContent([
      {
        NOTEBOOK_ID: "default",
        BOX_ID: "1",
        AI_PROMPT: "Welcome to the AI Content",
        AI_RESPONSE: "This is the default AI Content displayed when no notebook is associated with the selected subtopic.",
        AI_CONTENT_ID: "default_1"
      }
      ]);
      setFlashCardContent([]);
      return;
    }*/

		const fetchDataForNotebook = async () => {
			//logger.log("Fetching data for notebook...");
			//let userId = "1049";

			try {
				setMainPageLoader(true);
				const response = await fetchNotebookData(
					userId,
					topicId,
					subtopicId,
					notebookId.toString()
				);

				let responseData = response.data;
				//logger.log("Notebook data response: ", responseData);
				setSubject(responseData.subject);

				// Set AI content
				if (responseData.aiContent) {
					const newAIContent = responseData.aiContent?.map((item) => ({
						NOTEBOOK_ID: item.NOTEBOOK_ID,
						BOX_ID: item.BOX_ID,
						AI_PROMPT: item.AI_PROMPT,
						AI_RESPONSE: item.AI_RESPONSE,
						AI_CONTENT_ID: item.AI_CONTENT_ID,
						HAS_ATTACHMENT: item.HAS_ATTACHMENT,
						CREATED_AT: item.CREATED_AT,
						ATTACHMENTS: item.ATTACHMENTS?.map((attachment) => ({
							name: attachment.name,
							type: attachment.type,
							url: attachment.url,
						})),
					}));

					setAIContent(newAIContent);
				}

				// Set Flashcard content
				if (responseData.flashcard_data) {
					const newFlashcardContent = responseData.flashcard_data?.map((item) => ({
						NOTEBOOK_ID: item.NOTEBOOK_ID,
						BOX_ID: item.BOX_ID,
						FLASHCARDS_CONTENT: item.FLASHCARDS_CONTENT,
						FLASHCARD_ID: item.FLASHCARD_ID,
					}));
					setFlashCardContent(newFlashcardContent);
				}
				if (responseData.conceptQuiz_data) {
					const newQuizContent = responseData.conceptQuiz_data?.map((item) => ({
						id: item.CONCEPT_QUIZ_ID,
						notebookId: item.NOTEBOOK_ID,
						BOX_ID: item.BOX_ID,
						question: {
							text: item.question?.text,
						},
						options: item.options.map((option) => ({
							id: option.id, // Converts 0 -> 'A', 1 -> 'B', etc.
							text: option.text,
						})),
						correctAnswer: item.answer,
						explanation: item.explanation,
						hint: item.hint,
						step_hint: item.step_hint,
						extra_hint: item.extra_hint,
						ATTEMPTED: item?.ATTEMPTED || false,
						IS_CORRECT: item?.IS_CORRECT,
						USER_ANSWER: item?.USER_ANSWER,
					}));
					setConceptQuizData(newQuizContent);
					// if(newQuizContent.length > 0){
					//   setCurrentQuestion(newQuizContent[0]); // Set the first question as current
					//   setCurrentView("QuizPage");
					//   setIsLoading(false);
					// }
				}
			} catch (error) {
				logger.log('Error fetching notebook data: ', error);
			} finally {
				setMainPageLoader(false);
			}
		};
		if (notebookId) {
			fetchDataForNotebook();
		}
	}, [topicId, subtopicId, notebookId]);

	useEffect(() => {
		// Combine boxes from both AI Content and Flashcards
		//setShowFallback(false);
		setBoxes([]);
		let aiBoxes = [];
		if (aiContentData) {
			aiBoxes = aiContentData?.map((box) => ({
				BOX_ID: box.BOX_ID,
				CONTENT_TYPE: 'AI Content',
			}));
		}
		let flashcardBoxes = [];
		if (flashcard_content) {
			flashcardBoxes = flashcard_content?.map((box) => ({
				BOX_ID: box.BOX_ID,
				CONTENT_TYPE: 'Flashcard',
			}));
		}
		let quizBoxes = [];
		if (conceptQuizData) {
			// Since currentQuestion is a single object, not an array
			quizBoxes = conceptQuizData?.map((box) => ({
				BOX_ID: box.BOX_ID,
				CONTENT_TYPE: 'Quiz',
			}));
		}

		// Create a Map to store unique boxes by BOX_ID
		if (aiBoxes || flashcardBoxes || quizBoxes) {
			setBoxes((prevBoxes) => {
				const uniqueBoxesMap = new Map();
				[...prevBoxes, ...aiBoxes, ...flashcardBoxes, ...quizBoxes].forEach((box) => {
					uniqueBoxesMap.set(box.BOX_ID, {
						CONTENT_TYPE: box.CONTENT_TYPE,
						BOX_ID: box.BOX_ID,
					});
				});

				// Convert Map back to array
				return Array.from(uniqueBoxesMap.values());
			});
		}
	}, [aiContentData, flashcard_content, conceptQuizData]);

	useEffect(() => {
		const sorted = [...boxes].sort((a, b) => {
			return parseInt(a.BOX_ID, 10) - parseInt(b.BOX_ID, 10);
		});
		//logger.log("sortedBoxes: ", sorted);
		if (sorted.length === 0) {
			sorted.push({ CONTENT_TYPE: 'AI Content', BOX_ID: '1' });
		}
		setSortedBoxes(sorted);
		const latestBoxIdValue = String(Number(sorted[sorted?.length - 1]?.BOX_ID) + 1);
		setNewBoxId(latestBoxIdValue); // Track only the new box
	}, [boxes]);

	const handleNavClick = async (type) => {
		try {
			const latestBoxIdValue = String(
				Number(sortedBoxes[sortedBoxes?.length - 1]?.BOX_ID) + 1
			);
			setNewBoxId(latestBoxIdValue); // Track only the new box
			const newBox = {
				NOTEBOOK_ID: notebookId.toString(),
				TOPIC_ID: topicId,
				SUBTOPIC_ID: subtopicId,
				BOX_ID: latestBoxIdValue, // Use the response data
				CONTENT_TYPE: type,
			};
			console.log('newBox creation in handleNavClick', newBox);

			setSortedBoxes((prevSortedBoxes) => {
				const updatedBoxes = [
					...prevSortedBoxes,
					{ BOX_ID: newBox.BOX_ID, CONTENT_TYPE: newBox.CONTENT_TYPE },
				];
				return updatedBoxes;
			});
			if (type === 'Quiz') {
				handleStartQuiz(latestBoxIdValue);
			}
			setTimeout(() => {
				const scrollContainer = document.querySelector('.scrollable-content'); // Adjust if needed
				const newBoxElement = divRef?.current?.[latestBoxIdValue];

				if (scrollContainer && newBoxElement) {
					scrollContainer.scrollTo({
						top: newBoxElement.offsetTop - 270, // Adjust 20px to prevent navbar overlap
						behavior: 'smooth',
					});
				}
			}, 1000); //wait before scroll
		} catch (error) {
			logger.log('Error creating new box:', error);
			// Optionally handle the error in the UI
		}
	};

	const handleStartQuiz = async (latestBoxIdValue) => {
		setIsLoading(true);
		logger.log('conceptQuizData: ', conceptQuizData);

		// Step 1: Generate a summary of all topics discussed
		// const generateTopicSummary = (aiContentData) => {
		//   // Group content by topics using AI_PROMPT as identifier and track timestamps
		//   const topicGroups = aiContentData.reduce((groups, item, index) => {
		//     const topic = item.AI_PROMPT.toLowerCase();
		//     // Skip quiz generation prompts
		//     if (topic.includes("quiz") || topic.includes("create a question")) {
		//       return groups;
		//     }

		//     // Extract the main concept from the prompt
		//     const mainConcept = topic.split("?")[0].trim();
		//     if (!groups[mainConcept]) {
		//       groups[mainConcept] = [];
		//     }

		//     // Add response with its relative recency weight (more recent = higher weight)
		//     // Weight formula: 1 + (index / total_items)
		//     const recencyWeight = 1 + index / aiContentData.length;
		//     groups[mainConcept].push({
		//       content: item.AI_RESPONSE,
		//       weight: recencyWeight,
		//     });
		//     return groups;
		//   }, {});

		//   // Create a comprehensive summary for each topic
		//   return (
		//     Object.entries(topicGroups)
		//       .map(([topic, responses]) => {
		//         // Combine all responses for the topic, giving more weight to recent ones
		//         const weightedContent = responses
		//           .map((r) => r.content.repeat(Math.round(r.weight)))
		//           .join(" ");

		//         // Extract key information with weighted priority:
		//         // 1. Look for formulas (content between $ signs or after "formula" word)
		//         const formulas = [
		//           ...new Set(weightedContent.match(/\$([^$]+)\$/g) || []),
		//         ];

		//         // 2. Look for steps or methods (content after "steps:", "method:", or numbered lists)
		//         const steps = [
		//           ...new Set(
		//             weightedContent.match(/(?:steps:|method:)[^\n]+/gi) || []
		//           ),
		//         ];

		//         // 3. Look for examples (content after "example:" or "e.g.")
		//         const examples = [
		//           ...new Set(
		//             weightedContent.match(/(?:example:|e\.g\.)[^\n]+/gi) || []
		//           ),
		//         ];

		//         // Calculate topic importance based on recency weights
		//         const topicWeight =
		//           responses.reduce((sum, r) => sum + r.weight, 0) /
		//           responses.length;

		//         // Construct a structured summary with weight indicator
		//         let summary = `Topic: ${topic} (Relevance: ${topicWeight.toFixed(
		//           2
		//         )})\n`;

		//         if (formulas.length > 0) {
		//           summary += `Formulas: ${formulas.join(", ")}\n`;
		//         }

		//         if (steps.length > 0) {
		//           summary += `Key Methods: ${steps.join("; ")}\n`;
		//         }

		//         if (examples.length > 0) {
		//           summary += `Examples: ${examples.join("; ")}\n`;
		//         }

		//         // Add the most recent response with higher weight
		//         const mostRecent = responses[responses.length - 1].content;
		//         summary += `Latest Content: ${mostRecent}\n`;
		//         summary += "---\n";

		//         return {
		//           summary,
		//           weight: topicWeight,
		//         };
		//       })
		//       // Sort topics by their weights (most recent/relevant first)
		//       .sort((a, b) => b.weight - a.weight)
		//       .map((item) => item.summary)
		//       .join("\n")
		//   );
		// };

		// const topicSummary = generateTopicSummary(aiContentData);
		// logger.log("Topic Summary:", topicSummary);

		// let prompt =
		//   `Based on the following summary of previously discussed topics, generate a comprehensive SAT exam quiz question. The question should integrate concepts from multiple topics where possible. If not possible, randomly select one topic to ensure fair coverage of all material.\n\n` +
		//   `TOPIC SUMMARY:\n${topicSummary}\n\n` +
		//   `CONCEPT_QUIZ:\n${conceptQuizData}\n\n` +
		//   `IMPORTANT FORMATTING RULES:\n` +
		//   `1. Ensure correctness: Validate that the correct answer and explanation match logically before formatting.\n` +
		//   `2. For mathematical formulas, use LaTeX with proper escaping: \\\\( inline math \\\\) or \\\\[ display math \\\\]\n` +
		//   `3. For ratios, use proper HTML formatting with spans\n` +
		//   `4. For text-based questions, use regular paragraph tags\n` +
		//   `5. Ensure there is EXACTLY ONE correct answer\n` +
		//   `6. Re-evaluate the generated question and answer for any inconsistencies before formatting into JSON.\n` +
		//   `7. Step hints should be structured as a progressive breakdown of the EXPLANATION, ensuring that each step reveals a relevant portion of the full explanation while gradually guiding the student toward the answer. Each step should introduce a new part of the explanation without skipping ahead.
		//       Example Structure:
		//       Start with the general formula or definition used in the solution.
		//       Introduce the given values and how they are substituted.
		//       Show intermediate calculations.
		//       Arrive at the final solution.
		//       The number of steps should not be fixed; it should depend on the complexity of the explanation.
		//       Apply this structure to generate step hints from the given complete hint.\n` +
		//   `8. Don't repeat the same question in the quiz. Make sure the question is unique and not similar to the previous questions. Refer to the CONCEPT_QUIZ to ensure the question is unique with different variable values.\n` +
		//   `9. Calculate the correct answer and select the closest option from the given choices. Ensure proper rounding by comparing the absolute differences between the computed value and the answer choices. Always select the closest numerical value.\n` +
		//   `10. Always use chain of thought reasoning to generate the question and answer.\n` +
		//   `RESPONSE FORMAT REQUIREMENTS:\n` +
		//   `1. DO NOT include markdown code blocks (like \`\`\`json) in your response\n` +
		//   `2. DO NOT include any explanatory text before or after the JSON\n` +
		//   `3. Return ONLY the raw JSON object with no additional formatting\n` +
		//   `4. Begin your response DIRECTLY with the opening curly brace { and end with the closing curly brace }\n\n` +
		//   "{\n" +
		//   '  "question": { "text": "<p>Your question text here with proper math formatting if needed: \\\\(A = \\\\pi r^2\\\\)</p>" },\n' +
		//   '  "options": [\n' +
		//   '    { "id": "A", "text": "<p>First option with proper formatting</p>" },\n' +
		//   '    { "id": "B", "text": "<p>Second option with proper formatting</p>" },\n' +
		//   '    { "id": "C", "text": "<p>Third option with proper formatting</p>" },\n' +
		//   '    { "id": "D", "text": "<p>Fourth option with proper formatting</p>" }\n' +
		//   "  ],\n" +
		//   '  "answer": "Correct option ID (A, B, C, or D)",\n' +
		//   '  "explanation": "<p>Detailed solution with proper mathematical formatting if needed</p>",\n' +
		//   '  "hint": "<p>Helpful partial hint that guides without giving away the answer</p>",\n' +
		//   '  "step_hint": [\n' +
		//   '    { "text": "<p>First step - basic guidance</p>" },\n' +
		//   '    { "text": "<p>Second step - more detailed guidance</p>" },\n' +
		//   '    { "text": "<p>Third step - specific approach details</p>" },\n' +
		//   '    { "text": "<p>Fourth step - almost complete solution</p>" }\n' +
		//   "  ],\n" +
		//   '  "extra_hint": "<p>Helpful additional hint which is more informative than partial hint and guides without giving away the answer</p>"\n' +
		//   "}";

		// if (!prompt) {
		//   setIsLoading(false);
		//   return;
		// }

		try {
			// Step 1: Generate the quiz question
			// const formData = new FormData();
			// // formData.append("prompt", prompt);
			// formData.append("topicName", topicName);
			// formData.append("subtopicName", subtopicName);
			// logger.log("topicName: ", topicName);
			// logger.log("subtopicName: ", subtopicName);

			// const aiResponse = await getAIContentData(formData);
			const aiResponse = await getConceptQuiz(selectedMainTab, topicName, subtopicName);
			if (!aiResponse.success) {
				throw new Error(aiResponse.error || 'Failed to get AI response');
			}

			// Parse the string data into JSON
			let parsedData;
			try {
				parsedData =
					typeof aiResponse.data === 'string'
						? JSON.parse(aiResponse.data)
						: aiResponse.data;
				if (parsedData.data && typeof parsedData.data === 'string') {
					parsedData = JSON.parse(parsedData.data);
				}
			} catch (parseError) {
				logger.log('Error parsing JSON:', parseError);
				throw parseError;
			}
			// const boxIdResponse = await latestBoxId(topicId, subtopicId, notebookId);
			// if (!boxIdResponse.success) {
			//   throw new Error("Failed to get latest box ID");
			// }
			// Step 2: Save the quiz data to the database
			logger.log('parsedData: ', parsedData);
			const quizData = {
				// BOX_ID: boxIdResponse.data.latestBoxId.toString(),
				BOX_ID: latestBoxIdValue,
				NOTEBOOK_ID: notebookId.toString(),
				topicId,
				subtopicId,
				userId,
				question: parsedData.question,
				options: parsedData.options,
				answer: parsedData.answer,
				explanation: parsedData.explanation,
				hint: parsedData.hint,
				step_hint: parsedData.step_hint,
				extra_hint: parsedData.extra_hint,
				createdAt: new Date().toISOString(),
				// topicSummary: topicSummary, // Save this for context
			};

			// Save quiz data to database
			const savedQuiz = await saveQuizData(quizData);

			if (!savedQuiz.success) {
				throw new Error('Failed to save quiz data');
			}
			logger.log('quizData: ', quizData);
			// Step 3: Update the current question with the saved data
			setConceptQuizData((prevData) => [
				...prevData,
				{
					...quizData,
					id: savedQuiz.data.CONCEPT_QUIZ_ID, // Store the database ID
				},
			]);

			// Step 4: Switch to quiz view
			setCurrentView('QuizPage');
			showToast('Quiz generated successfully', 'success');
		} catch (error) {
			logger.log('Error in quiz generation/saving:', error);
			// Show error message to user
			setError('Failed to generate quiz. Please try again.');
			showToast('Failed to generate quiz. Please try again.', 'error');
		} finally {
			setIsLoading(false);
		}
	};

	if (showFallback) {
		return (
			<div className="main-section">
				<div className="no-data">Notebook data not found.</div>
			</div>
		);
	}

	const backgroundColor = (box) => {
		if (box?.CONTENT_TYPE === 'AI Content') {
			return 'rgba(41, 98, 255, 0.1)';
		} else if (box?.CONTENT_TYPE === 'Flashcard') {
			return 'rgba(255, 145, 0, 0.1)';
		} else if (box?.CONTENT_TYPE === 'Quiz') {
			return 'rgba(1, 191, 166, 0.1)';
		} else {
			return 'rgba(0, 0, 0, 0.2)';
		}
	};

	const handleClick = (event, boxID) => {
		if (divRef?.current?.[boxID]) {
			const rect = divRef?.current?.[boxID]?.getBoundingClientRect();
			logger.log(
				'rect.top',
				rect.top,
				'rect.left',
				rect.left,
				'rect.width',
				rect.width,
				'rect.height',
				rect.height
			);
			logger.log('top', rect.top + rect.height / 2 + window.scrollY);
			const obj = {
				top: rect.top + rect.height / 3.2,
				left: rect.left + rect.width / 2,
			};
			logger.log('obj', obj);
			setPopoverState(boxID);
			setAnchorPosition(obj);
		}
	};
	const handleClose = () => {
		setPopoverState(false);
		setAnchorPosition(null);
		logger.log('Close clicked');
	};
	// const handleMenu = () => {

	// }

	// Define the showToast function
	const showToast = (message, type = 'error') => {
		switch (type) {
			case 'success':
				toast.success(message);
				break;
			case 'info':
				toast.info(message);
				break;
			case 'warning':
				toast.warning(message);
				break;
			case 'error':
			default:
				toast.error(message);
				break;
		}
	};

	return (
		<div className="main-section">
			{mainPageLoader ? (
				<Loader />
			) : (
				<React.Fragment>
					<div className="nav-bar-learninginterface">
						<button
							className={`nav-button-learninginterface AIC ${
								activeBox === 'AI Content' ? 'active' : ''
							}`}
							onClick={() => handleNavClick('AI Content')}
						>
							{/* <DescriptionIcon className="nav-icon"/>  */}
							<div style={{ position: 'relative', display: 'inline-block' }}></div>
							<img
								src={DescriptionIcon}
								alt="DescriptionIcon"
								width="20"
								height="20"
							/>
							<span className="nav-text">AI Content</span>
						</button>
						<button
							className={`nav-button-learninginterface Qui ${
								activeBox === 'Quiz' ? 'active' : ''
							}`}
							onClick={() => {
								// if (aiContentData.length === 0) {
								//   showToast("No AI content found");
								//   return;
								// }

								handleNavClick('Quiz');

								// setTimeout(() => {
								// 	scrollToQuizBox();
								// }, 800);
								// setCurrentView("Instructions");
							}}
						>
							{/* <LightbulbIcon className="nav-icon" />{" "} */}
							<img src={LightbulbIcon} alt="LightbulbIcon" width="20" height="20" />
							<span className="nav-text">Concept Quiz</span>
						</button>
						<button
							className={`nav-button-learninginterface Fla ${
								activeBox === 'Flashcard' ? 'active' : ''
							}`}
							onClick={() => handleNavClick('Flashcard')}
						>
							{/* <SchoolIcon className="nav-icon" />{" "} */}
							<img src={SchoolIcon} alt="SchoolIcon" width="20" height="20" />
							<span className="nav-text">Flashcard</span>
						</button>
					</div>
					<Box
						className="scrollable-content"
						sx={{
							width: '100%',
							height: 'calc(100vh - 230px)',
							overflowY: 'auto',
							padding: { xs: '1rem 1.25rem', sm: '2rem 4rem' },
							scrollbarWidth: 'none',
							'-ms-overflow-style': 'none',
							display: 'flex',
							flexDirection: 'column',
							gap: '1rem',
							'&::-webkit-scrollbar': {
								display: 'none', // Chrome, Safari, Opera
							},
						}}
					>
						{anchorPosition && (
							<Popover
								open={Boolean(anchorPosition)}
								onClose={() => handleClose()}
								// sx={{ maxHeight: "250px" }}
								anchorReference="anchorPosition"
								anchorPosition={anchorPosition}
								transformOrigin={{
									vertical: 'center',
									horizontal: 'center',
								}}
							>
								<NotesMenu
									boxID={popoverState}
									notebookId={notebookId}
									handleClose={handleClose}
								/>
							</Popover>
						)}
						{sortedBoxes?.map((box) => (
							<div key={box.BOX_ID}>
								<div
									ref={(el) => (divRef.current[box.BOX_ID] = el)}
									className={`content ${
										box.CONTENT_TYPE === 'Quiz' ? 'quiz-content' : ''
									}`}
									style={{
										backgroundColor: backgroundColor(box),
									}}
								>
									<Box
										sx={{ display: 'flex', justifyContent: 'flex-end' }}
										id={box.BOX_ID}
									>
										<ChatBubbleIcon
											sx={{
												marginRight: '2rem',
												marginTop: '1rem',
												color: '#FFAB31',
												cursor: 'pointer',
											}}
											onClick={(e) => {
												logger.log('clicked');
												handleClick(e, box.BOX_ID);
											}}
										/>
									</Box>
									{/* Render content dynamically based on the box type */}
									{box.CONTENT_TYPE === 'AI Content' && (
										<AIContent
											key={`${box.BOX_ID}-${notebookId}`}
											ai_content_data={aiContentData?.filter(
												(content) => content.BOX_ID === box.BOX_ID
											)}
											boxId={box.BOX_ID}
											notebookId={notebookId}
											topicId={topicId}
											subtopicId={subtopicId}
											setAIContent={setAIContent}
										/>
									)}

									{box.CONTENT_TYPE === 'Flashcard' && (
										<Flashcard
											flashcard_data={flashcard_content
												.filter((content) => content.BOX_ID === box.BOX_ID)
												.map((content) => content.FLASHCARDS_CONTENT)}
											boxId={box.BOX_ID}
											topicId={topicId}
											subtopicId={subtopicId}
											subject={subject}
											newBoxId={newBoxId}
											isNewBox={box.BOX_ID === newBoxId}
											ai_content_data={aiContentData}
										/>
									)}

									{box.CONTENT_TYPE === 'Quiz' &&
										conceptQuizData.find(
											(quiz) => quiz.BOX_ID === box.BOX_ID
										) && (
											<QuizPage
												currentQuestion={conceptQuizData.find(
													(quiz) => quiz.BOX_ID === box.BOX_ID
												)}
												topicId={topicId}
												subtopicId={subtopicId}
											/>
										)}
									{/* {box.CONTENT_TYPE === "Quiz" && !conceptQuizData.find(quiz => quiz.BOX_ID === box.BOX_ID) && isLoading === false && (
              <SubtopicQuizInstructions handleStartQuiz={handleStartQuiz} />
            )} */}
									{box.CONTENT_TYPE === 'Quiz' &&
										!conceptQuizData.find(
											(quiz) => quiz.BOX_ID === box.BOX_ID
										) &&
										isLoading && (
											<div
												className="loader-container"
												style={{
													height: 'calc(100% - 60px)',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
												}}
											>
												<div className="loader"></div>
												<p>Generating quiz question...</p>
											</div>
										)}
								</div>
							</div>
						))}
					</Box>
					<ToastContainer />
				</React.Fragment>
			)}
			;
		</div>
	);
};

export default LearningInterface;
